<template>
  <div>
    <el-row id="content-title">
      <el-col>
        <div class="d-flex align-items-center">
          <h3 class="mb-0">Currency</h3>
          <div class="ml-auto">
            <router-link
              class="el-button el-button--primary el-button--mini"
              :to="{ name: 'currency_info' }"
              title="Create new supplier"
              ><i class="el-icon-magic-stick"></i> New</router-link
            >
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <router-view :key="$route.fullPath"></router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "index",

  data() {
    return {};
  }
};
</script>

<style lang="css" scoped></style>
